// React.
import React from 'react';

// Material UI.
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Table } from '@material-ui/core';

// Translations.
import { useTranslation } from 'react-i18next';

// Styles.
import useStyles from './PointsComponentsStyles';

interface PointsTransactionsTableProps {
  transactions: any;
  width: number;
}

const PointsTransactionsTable = ({ transactions, width }: PointsTransactionsTableProps) => {
  const classes = useStyles();
  const [t] = useTranslation('global');

  return (
    <Table size="medium" aria-label="a dense table" className={classes.tableWrapper}>
      <TableHead>
        <TableRow>
          <TableCell>{t('logs.date')}</TableCell>
          <TableCell>{t('logs.total-used')}</TableCell>
          <TableCell>{t('users.expiration-date')}</TableCell>
          {width > 600 ? <TableCell>{t('logs.reason')}:</TableCell> : <></>}
        </TableRow>
      </TableHead>
      <TableBody>
        {transactions !== undefined ? transactions.content.map((transaction: any, index: number) => {
          const dateMatch = transaction.reason?.match(/\|\s*(\d{4}-\d{2}-\d{2})/);
          const expirationDate = dateMatch ? dateMatch[1] : 'N/A';
          const reasonWithoutDate = transaction.reason?.replace(/\|\s*\d{4}-\d{2}-\d{2}/, '').trim();
          return (
            <TableRow key={index}>
              <TableCell component="th" scope="row">
                {transaction.creationDate.substring(0, 10)}
              </TableCell>
              <TableCell>
                {
                  transaction.newValue < transaction.oldValue ?
                    transaction.oldValue - transaction.newValue :
                    transaction.newValue - transaction.oldValue
                }
              </TableCell>
              <TableCell>
                {expirationDate}
              </TableCell>

              {width > 600 ? <TableCell>
                <div className={classes.Reason}>{reasonWithoutDate || transaction.reason}</div>
              </TableCell> : <></>}
            </TableRow>
          )
        }) : <TableRow>Loading...</TableRow>}
      </TableBody>
    </Table>
  );
};

export default PointsTransactionsTable;
